/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_New_FolderInputs */

const en_home_v2_new_folder = /** @type {(inputs: Home_V2_New_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New folder`)
};

const es_home_v2_new_folder = /** @type {(inputs: Home_V2_New_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva carpeta`)
};

/**
* | output |
* | --- |
* | "New folder" |
*
* @param {Home_V2_New_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_new_folder = /** @type {((inputs?: Home_V2_New_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_New_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_new_folder(inputs)
	return en_home_v2_new_folder(inputs)
});